module.exports = __webpack_public_path__ + "img/swiper-8.69190686.png";